// RyzenOS license keys
// ----------------------------------------------------------------------------
// When a customer registers with Ryzenforge manually, issue them a key and add
// a row to ISSUED_KEYS below. The key they type on the "Sign in with a license
// key" screen is validated here, and the plan + seat limit are derived from it.
//
// Key format:  RYZ-<PLAN>-XXXXX-XXXXX
//   PLAN prefix ->  STR = Starter (3 users)
//                   GRW = Growth  (6 users)
//                   BUS = Business (unlimited users)
// The XXXXX groups are 5 uppercase letters/digits each. Example:
//   RYZ-GRW-8Q7WZ-4F9K2
//
// A key works as soon as it matches the format (the plan is read from the
// prefix), so you can hand out keys immediately. Adding the key to ISSUED_KEYS
// is optional but recommended: it lets you attach the company name, an issue
// date, and disable a key later by removing its row.

export const PLAN_SEATS = { starter: 3, growth: 6, business: null }; // null = unlimited
export const PLAN_LABEL = { starter: 'Starter', growth: 'Growth', business: 'Business' };

// Keys you have issued. Add one line per customer.
export const ISSUED_KEYS = [
  // { key: 'RYZ-GRW-8Q7WZ-4F9K2', plan: 'growth', company: 'Acme Studio', issued: '2026-07-15' },
];

const PREFIX_PLAN = { STR: 'starter', GRW: 'growth', BUS: 'business' };
const KEY_RE = /^RYZ-(STR|GRW|BUS)-[A-Z0-9]{5}-[A-Z0-9]{5}$/;

export function normalizeKey(raw) {
  return (raw || '').trim().toUpperCase().replace(/\s+/g, '');
}

// Returns { valid, plan, seats, company, key } or { valid:false, error }
export function validateLicenseKey(raw) {
  const key = normalizeKey(raw);
  if (!key) return { valid: false, error: 'Enter your license key' };

  // 1) Exact match against an issued key (source of truth)
  const found = ISSUED_KEYS.find((k) => normalizeKey(k.key) === key);
  if (found) {
    const plan = found.plan;
    return {
      valid: true,
      plan,
      seats: found.seats != null ? found.seats : PLAN_SEATS[plan],
      company: found.company || '',
      key,
    };
  }

  // 2) Fallback: valid format -> derive plan from the prefix
  const m = key.match(KEY_RE);
  if (m) {
    const plan = PREFIX_PLAN[m[1]];
    return { valid: true, plan, seats: PLAN_SEATS[plan], company: '', key };
  }

  return { valid: false, error: 'This key is not valid. Contact Ryzenforge to get your key.' };
}

// Persisted license helpers
const LICENSE_KEY = 'ryzenos_license';
export function saveLicense(info) {
  localStorage.setItem(LICENSE_KEY, JSON.stringify({ key: info.key, plan: info.plan, seats: info.seats, company: info.company || '' }));
}
export function getLicense() {
  try { return JSON.parse(localStorage.getItem(LICENSE_KEY) || 'null'); } catch { return null; }
}
export function seatLimit() {
  const lic = getLicense();
  if (!lic) return null;             // no license on record -> no client-side cap
  return lic.seats == null ? null : lic.seats; // null = unlimited
}
